import { ApiError } from "@/modules/api/ApiError.ts";
import { errorInfoAsString } from "@/modules/error/errorToString.ts";
import { LocalizedErrorMessage } from "@/modules/l10n/LocalizedErrorMessage.tsx";
import type { ReactNode } from "react";

export function errorToReactMessage(error: unknown): ReactNode {
    if (error instanceof ApiError) {
        // XXX: API errors are not localized yet
        const {
            errorMessage,
            meta: { correlationId, status },
        } = error;
        return (
            <span className="whitespace-pre-wrap">
                {errorMessage}{" "}
                <span className="text-muted">
                    {correlationId != null ? `[${correlationId}] ` : null}(HTTP {status}) ({errorInfoAsString(error)})
                </span>
            </span>
        );
    }

    return (
        // Error messages can contain literal "\n" so convert these to real line breaks
        <span className="whitespace-pre-wrap">
            <LocalizedErrorMessage error={error} />
        </span>
    );
}
